import React, { useState, useEffect } from "react";

export default function DateTimeField({ value, onChange, editable }) {
  const [editValue, setEditValue] = useState("");

  const formatForInput = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  
  useEffect(() => {
    setEditValue(formatForInput(value));
  }, [value]);

  const handleChange = (e) => {
    const localVal = e.target.value;
    setEditValue(localVal);
    if (onChange) onChange(localVal);
  };

  // console.log(editValue)

  return (
    <input
      type="datetime-local"
      value={editValue}
      onChange={handleChange}
      readOnly={!editable}
      placeholder="YYYY-MM-DD HH:mm"
      step="60"
      style={{ textTransform: "none" }}
    />
  );
}
